import React, { useState } from 'react';
import SummaryForm from './summaryForms';
import MainPaymentPage from '../payment';
import MainRoutePage from '../route';
import PackagesContainer from '../packages';
interface Props {
  setShowSummary: any;
  setShowRates?: any;
  setCurrentShipmentStatus: any;
  setShowPickup?: any;
  setShowRoutes?: any;
}
function MainSummaryPage({
  setShowSummary,
  setCurrentShipmentStatus,
  setShowRates,
  setShowPickup,
  setShowRoutes,
}: Props) {
  const [showPayment, setShowPayment] = useState(false);
  const [editRouteForm, setEditRouteForm] = useState(false);
  const [editPackageForm, setEditPackageForm] = useState(false);
  return (
    <div>
      {!showPayment && !editRouteForm && !editPackageForm ? (
        <SummaryForm
          setShowSummary={setShowSummary}
          setShowRates={setShowRates && setShowRates}
          setShowPayment={setShowPayment}
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setEditRouteForm={setEditRouteForm}
          setEditPackageForm={setEditPackageForm}
          setShowPickup={setShowPickup && setShowPickup}
          setShowRoutes={setShowRoutes && setShowRoutes}
        />
      ) : editRouteForm ? (
        <MainRoutePage setCurrentShipmentStatus={setCurrentShipmentStatus} />
      ) : editPackageForm ? (
        <PackagesContainer
          setCurrentShipmentStatus={setCurrentShipmentStatus}
          setShowAttention={undefined}
          setShowPackages={undefined}
          isOpenedFromSummary={true}
        />
      ) : (
        showPayment && (
          <MainPaymentPage
            setShowSummary={setShowSummary}
            setShowPayment={setShowPayment}
            setCurrentShipmentStatus={setCurrentShipmentStatus}
          />
        )
      )}
    </div>
  );
}

export default MainSummaryPage;
